<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="form-group">
    <div class="mb-20">
      <label class="form-label required">Short code </label>
      <input formControlName="phoneNumber" type="text" class="form-control">
      <input-errors [control]="form.controls.phoneNumber" [service]="validationService"></input-errors>
    </div>
    <div class="mb-20">
      <label class="form-label required">Country</label>
      <div class="position-relative">
        <select formControlName="country" class="form-control" (change)="onCountryChange($event.target.value)">
          <option *ngFor="let country of countries" [value]="getValue(country)">
            {{ getValue(country) }}
          </option>
        </select>
        <i class="fas fa-chevron-down position-absolute end-0 top-50 translate-middle-y pe-10"></i>
      </div>
      <input-errors [control]="form.controls.country" [service]="validationService"></input-errors>
    </div>
    <div *ngIf="isAdmin" class="mb-20">
      <label class="form-label required">User </label>
      <div>
        <span (click)="showUserListModal()" class="text-navy editable-text cp">
          <span *ngIf="!selectedUser">Select user</span>
          <span *ngIf="selectedUser">{{ selectedUser.email }} &lt;{{ selectedUser.username }}&gt;</span>
        </span>
      </div>
    </div>
    <div class="mb-20">
      <label class="form-label">Description</label>
      <textarea formControlName="description" type="text" class="form-control" rows="5"></textarea>
      <input-errors [control]="form.controls.description" [service]="validationService"></input-errors>
    </div>
  </div>
  <div class="d-flex justify-content-end my-10">
    <button type="submit" [disabled]="!isFormValid()" class="btn btn-primary px-40">Apply</button>
  </div>
</form>


<ng-template #userListModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Select user</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-users-select [multiple]="false" [roles]="['mainaccount']" (selectUser)="onSelectUser($event)"></app-users-select>
  </div>
</ng-template>
